import React from 'react'
import { useMaasAccount } from '@maas-tools/accounts'
import PropTypes from 'prop-types'
import { SUPPORT_TICKETS_URL } from 'core/common/constants/settings'
import i18n from 'core/common/i18n'
import { getPermissions } from 'core/common/utils/permissions'
import { Button } from 'core/components/Core'
import Result, { ResultActionArea } from 'core/components/Result'

const AppPermission = ({ children }) => {
  const account = useMaasAccount()
  const currentPermissions = getPermissions(account)

  /**
   * Condicional caso o account der alguma inconsistência ao retornar o seller atual.
   */
  if (!account?.currentSeller) {
    return (
      <Result
        status="500"
        title={i18n.t('error.AC001.title')}
        subtitle={i18n.t('error.AC001.subtitle')}
      >
        <ResultActionArea hasLogout>
          <Button target="_blank" href={SUPPORT_TICKETS_URL} variant="contained" color="primary">
            {i18n.t('error.AC001.labelAction')}
          </Button>
        </ResultActionArea>
      </Result>
    )
  }

  /**
   * Condicional caso o account não retorne nenhum serviço associado para o seller.
   */
  if (!account?.currentSeller?.services?.length) {
    return (
      <Result
        status="500"
        title={i18n.t('error.AC002.title')}
        subtitle={i18n.t('error.AC002.subtitle')}
      >
        <ResultActionArea hasLogout>
          <Button target="_blank" href={SUPPORT_TICKETS_URL} variant="contained" color="primary">
            {i18n.t('error.AC002.labelAction')}
          </Button>
        </ResultActionArea>
      </Result>
    )
  }

  /**
   * Condicional caso o seller não possuir acesso a aplicação.
   */
  if (!currentPermissions?.length) {
    return (
      <Result
        status="403"
        title={i18n.t('error.403.title')}
        subtitle={i18n.t('error.403.subtitle')}
      >
        <ResultActionArea hasLogout>
          <Button target="_blank" href={SUPPORT_TICKETS_URL} variant="contained" color="primary">
            {i18n.t('error.403.labelAction')}
          </Button>
        </ResultActionArea>
      </Result>
    )
  }

  return children
}

AppPermission.propTypes = {
  children: PropTypes.element.isRequired,
}

export default AppPermission
